import React from 'react';
import { Stack } from '@cp/ds/src/components/stack';
import { DotMark } from '@cp/ds/src/components/dotMark';
import { Typography } from '@cp/ds/src/components/typography';
import { MOBILE_BREAKPOINT_THRESHOLD } from '@cp/ds/src/theme';
import { CatalogClientsOnlineTotalCounterProps } from './types';

export const CatalogClientsOnlineTotalCounter: React.FC<CatalogClientsOnlineTotalCounterProps> = ({}) => {
  // TODO: request count from api server
  return (
    <Stack direction="row" spacing={1.5} sx={{ alignItems: 'center' }}>
      <DotMark color="green" />
      <Typography sx={{ typography: { xs: 'body', [MOBILE_BREAKPOINT_THRESHOLD]: 'button' } }}>574 сейчас на сайте</Typography>
    </Stack>
  );
};
